import { render, staticRenderFns } from "./StatsTile.vue?vue&type=template&id=248d1cde&scoped=true&"
import script from "./StatsTile.vue?vue&type=script&lang=js&"
export * from "./StatsTile.vue?vue&type=script&lang=js&"
import style0 from "./StatsTile.vue?vue&type=style&index=0&id=248d1cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d1cde",
  null
  
)

export default component.exports